import { render, staticRenderFns } from "./file-open-svg.vue?vue&type=template&id=35c3b857&scoped=true&"
var script = {}
import style0 from "./file-open-svg.vue?vue&type=style&index=0&id=35c3b857&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3b857",
  null
  
)

export default component.exports